import * as Yup from "yup";

const enterAnEmail = "Enter an email address";

export const validationSchema = Yup.object().shape({
  suspectEmail: Yup.string().email(enterAnEmail).required(enterAnEmail),
  reason: Yup.string(),
  jobId: Yup.string(),
});
